import React, { Component } from 'react'
import _ from 'lodash'
import Header from './header'
import ill from './../../../include/images/ill.svg'
import arrowtr from './../../../include/images/arrow-tr.svg'
import dashbImg from './../../../include/images/dashboard.svg'
import consultation from './../../../include/images/consultation.svg'
import sstar from './../../../include/images/shield-with-star.svg'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getMisc, loadFieldType, loadFilterCity, loadFilterLanguages } from '../../../store/misc'
import { getDoctor, loadDoctors } from '../../../store/doctor'
import LoadingBar from 'react-top-loading-bar'
import crossIcon from '../../../include/images/cross.svg'
import pinImg from '../../../include/images/pin.svg'
import locationIcon from '../../../include/images/location-icon.svg'
import specialist4 from "./../../../include/images/specialist4.svg";
import faqs from "./../../../include/images/circle-question-solid.svg";
import askMindy from '../../../include/images/help.svg'
import moment from 'moment'
import { Helmet } from 'react-helmet-async';

import {
  getAppointment,
  loadDate,
  loadSlot,
  createOrder,
  updateOrder,
  earliestOnline,
} from '../../../store/appointment'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import OrderReview from './appointment/orderReview'
import TypeSwitch from './appointment/typeSwitch'
import DateTimeSelection from './appointment/dateTimeSelection'
import InfiniteScroll from 'react-infinite-scroller'
import {
  loadPatientProfile,
  getPatient,
  setShowSuccessData,
} from '../../../store/patient'
import Footer from '../../home/footer'
import { FilterChip } from './filterChip'
import { FilterModal } from './filterModal'
const ref = React.createRef(null)

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const fees = [
  '',
  { $lte: 500 },
  { $lte: 700, $gte: 500 },
  { $lte: 1000, $gte: 700 },
  { $lte: 1500, $gte: 1000 },
  { $gte: 1500 },
]
const phyFees = [
  '',
  { $lte: 500 },
  { $lte: 700, $gte: 500 },
  { $lte: 1000, $gte: 700 },
  { $lte: 1500, $gte: 1000 },
  { $gte: 1500 },
]

const experience = [
  '',
  { $lte: 2 },
  { $lte: 5, $gte: 2 },
  { $lte: 10, $gte: 5 },
  { $lte: 15, $gte: 10 },
  { $gte: 15 },
]

const feeRanges = [
  "Under ₹500",
  "₹500–₹700",
  "₹700–₹1000",
  "₹1000–₹1500",
  "Over ₹1500",
];

const expYears = [
  "Under 2 years",
  "2–5 years",
  "5–10 years",
  "10–15 years",
  "Over 15 years",
];


class ourDoctors extends Component {
  state = {
    customer: localStorage.getItem('customer_details')
      ? JSON.parse(localStorage.getItem('customer_details'))
      : {},
    params: {
      'field_type.id': '5fe61886084b3e3d4e6c7978',
      'gender': [],
      'cityId': [],
      'feesNumber': [],
      'physicalFee': [],
      'language': [],
      'experienceNumber': [],
    },
    filters: {
      earliestOnline: false,
      experienceNumber: null,
      feesNumber: null,
      physicalFee: null,
      language: null,
      gender: null,
      city: null,
    },
    activeModal: null,
    page: 1,
    page2: 1,
    doctorProfile: '',
    selectedDate: '',
    selectedTime: '',
    preview: false,
    loading: false,
    orderDetail: {},
    apType: 'clinic',
    sideBar: '',
    Psychiatrist: '',
    Psychologist: '',
    name: '',
    viewMode: "all",
    earliestDoctors: [],
    loadingEarliest: false
  }

  setName = e => {
    this.setState({ name: e.target.value }, () =>
      this.props.loadDoctor(this.arrangeParam())
    )
  }

  applyFilter = () => {
    // console.log("this.arrangeParam() : ",this.arrangeParam())
    this.props.loadDoctor(this.arrangeParam())
  }

  openModal = (type) => {
    this.setState({ activeModal: type });
  };

  closeModal = () => {
    this.setState({ activeModal: null });
  };

  doSubmit = type => {
    //alert(this.state.selectedDate);
    this.setState({ loading: true })
    if (type === 'clinic') {
      this.setState(
        {
          preview: true,
          loading: false,
          apType: type,
          orderDetail: {
            ret: {
              appointment_time: this.state.selectedTime,
              appointment_type: 'clinic',
              consultation_charges: Number(
                this.props.getDoctor.doctors.data[this.state.doctorProfile]
                  .schedules.clinicFee
              ),
            },
          },
          sideBar: 'appointment',
        },
        () => {
          document.body.classList.add('toggled-tab')
        }
      )
    } else {
      const payLoad = {
        appointment_time: moment(this.state.selectedTime).utc(),
        doctor_id:
          this.props.getDoctor.doctors.data[this.state.doctorProfile]._id,
        type: type,
      }
      console.log('payLoadpayLoad', payLoad)
      this.props.createOrder(payLoad, this.callBackOrder)
    }
  }

  callBackPayment = res => {
    this.props.loadPatientProfile()
    this.removeBodyClass()
    if (res.status === 200) {
      this.props.setShowSuccessData(true)
      this.props.history.push('/patient/dashboard')
      // this.props.history.push("/patient/appointment-success");
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  callBackOrderLogin = res => {
    this.props.loadPatientProfile()
    this.removeBodyClass()
    if (res.status === 200) {
      this.props.setShowSuccessData(true)
      this.props.history.push('/patient/dashboard')
      //toast(<AlertSuccess message={"Payment success"} />);
      // this.props.history.push("/patient/appointment-success");
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  payNow = e => {
    e.preventDefault()
    if (this.state.apType === 'clinic') {
      const payLoad = {
        appointment_time: this.state.selectedTime,
        doctor_id:
          this.props.getDoctor.doctors.data[this.state.doctorProfile]._id,
        type: this.state.apType,
      }
      this.props.createOrder(payLoad, this.callBackOrderLogin)
    } else {
      const res = this.state.orderDetail
      const patientData = JSON.parse(localStorage.getItem('patient'))
      var options = {
        key: process.env.REACT_APP_REZORPAY,
        amount: res.rpay.amount_due * 100,
        currency: 'INR',
        name: 'YesMindy',
        description: 'Appointment',
        image:
          process.env.REACT_APP_S3URL +
          'website/yes-mindy-color-logo-small.png',
        order_id: res.rpay.id,
        handler: response => {
          this.props.updateOrder(
            { payment_info: response },
            this.callBackPayment
          )
        },
        prefill: {
          name: patientData.first_name + ' ' + patientData.last_name,
          email: patientData.email,
          contact: patientData.mobile,
        },
        notes: {
          address: 'Appointment',
        },
        theme: {
          color: '#621ac0',
        },
      }
      var rzp1 = new window.Razorpay(options)
      rzp1.on('payment.failed', function (response) {
        console.log('paymentfailed', response)
      })
      rzp1.open()
    }
  }

  callBackOrder = res => {
    if (res && res.data)
      this.setState({ preview: true, loading: false, orderDetail: res.data })
  }

  componentDidMount = () => {
    // this.props.loadPatientProfile()
    this.props.loadDoctor(this.arrangeParam())
    this.props.loadFieldType({ filter: true })
    this.props.loadFilterCity()
    this.props.loadFilterLanguages()
    if (
      this.props.location.state &&
      this.props.location.state.field_type &&
      this.props.getMisc.fieldTypes.length
    ) {
      const defaultF = this.props.getMisc.fieldTypes.find(
        ef => ef.name === this.props.location.state.field_type
      )
      const { params } = this.state
      params['field_type.id'] = defaultF.id
      this.setState({ params })
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.getMisc.loadingFieldTypes &&
      this.props.getMisc.loadingFieldTypes !==
        prevProps.getMisc.loadingFieldTypes
    ) {
      if (this.props.location.state && this.props.location.state.field_type) {
        const defaultF = this.props.getMisc.fieldTypes.find(
          ef => ef.name === this.props.location.state.field_type
        )
        const { params } = this.state
        params['field_type.id'] = defaultF.id
        this.setState({ params }, () => this.props.loadDoctor(this.arrangeParam()))
      }
    }
    if (
      !this.props.getPatient.loading &&
      this.props.getPatient.loading !== prevProps.getPatient.loading
    ) {
      const { Psychologist, Psychiatrist } = this.props.getPatient.profile
      this.setState({ Psychologist, Psychiatrist }, () =>
        this.props.loadDoctor(this.arrangeParam())
      )
    }
    if (
      !this.props.getDoctor.doctorLoading &&
      this.props.getDoctor.doctorLoading !== prevProps.getDoctor.doctorLoading
    ) {
      ref.current.complete()
    }
    if (!this.props.getAppointment.loadingDates) {
      ref.current.complete()
    }
    if (this.props.getAppointment.loadingDates) {
      ref.current.continuousStart()
    }
  }
  
  arrangeParam = () => {
    const params = { ...this.state.params }
    const experienceData = params.experienceNumber.map(e => experience[e])
    const feesData = params.feesNumber.map(e => fees[e])
    // console.log("fees Data : ----> ", feesData)
    const physicalFee = params.physicalFee.map(e => phyFees[e])
    const final = { page: this.state.page }
    if (params['field_type.id'])
      final['field_type._id'] = params['field_type.id']
    if (params.gender.length === 1) final.sex = params.gender[0]
    if (params.cityId.length) final.cityId = params.cityId
    if (params.feesNumber.length) final.fees = feesData
    if (params.physicalFee.length) final.phyFees = physicalFee
    if (params.language.length) final.language = params.language
    if (params.experienceNumber.length) final.experience = experienceData
    if (this.state.name) final.name = this.state.name
    if (
      this.state.Psychiatrist &&
      params['field_type.id'] === '5fe61886084b3e3d4e6c7978'
    ) {
      final.id = this.state.Psychiatrist
    }
    if (
      this.state.Psychologist &&
      params['field_type.id'] === '5fe619be084b3e3d4e6c7979'
    ) {
      final.id = this.state.Psychologist
    }

    return final
  }

  updateParams = (key, val, e) => {
    ref.current.continuousStart()
    if (e) e.preventDefault()
    const params = { ...this.state.params }
    params[key] = val

    if(this.state.filters.earliestOnline){
      const filter = {
        field_type: val,
        page: 1
      }
      this.setState({ params, doctorProfile: '' }, () =>
        this.props.earliestOnline(filter, this.earlistCallback)
      )
    } else {
      this.setState({ params, doctorProfile: '' }, () =>
      this.props.loadDoctor(this.arrangeParam())
    )
    }
  }

  handleResetFilters = () => {
    this.setState(
      {
        params: {
          'field_type.id': '5fe61886084b3e3d4e6c7978',
          gender: [],
          cityId: [],
          feesNumber: [],
          physicalFee: [],
          language: [],
          experienceNumber: [],
        },

        filters: {
          earliestOnline: false,
          experienceNumber: null,
          feesNumber: null,
          physicalFee: null,
          language: null,
          gender: null,
          city: null,
        },

        activeModal: null,
        page: 1,
      },
      () => {
        this.props.loadDoctor(this.arrangeParam());
      }
    );
  };

  changeGender = mf => {
    let params = { ...this.state.params }
    const find = params.gender.find(v => v === mf)
    if (find) {
      const f = params.gender.filter(vf => vf !== mf)
      params.gender = f
    } else {
      params.gender.push(mf)
    }
    this.setState({ params })
  }

  changeCity = cityId => {
    let params = { ...this.state.params }
    const find = params.cityId.find(v => v === cityId)
    if (find) {
      const f = params.cityId.filter(vf => vf !== cityId)
      params.cityId = f
    } else {
      params.cityId.push(cityId)
    }
    this.setState({ params })
  }

  changeLang = Lang => {
    let params = { ...this.state.params }
    const find = params.language.find(v => v === Lang)
    if (find) {
      const f = params.language.filter(vf => vf !== Lang)
      params.language = f
    } else {
      params.language.push(Lang)
    }
    this.setState({ params })
  }
  changeFees = number => {
    let params = { ...this.state.params }
    const find = params.feesNumber.find(v => v === number)
    if (find) {
      const f = params.feesNumber.filter(vf => vf !== number)
      params.feesNumber = f
    } else {
      params.feesNumber.push(number)
    }
    this.setState({ params })
  }

  changePhysicalFees = number => {
    let params = { ...this.state.params }
    const find = params.physicalFee.find(v => v === number)
    if (find) {
      const f = params.physicalFee.filter(vf => vf !== number)
      params.physicalFee = f
    } else {
      params.physicalFee.push(number)
    }
    this.setState({ params })
  }

  changeExp = number => {
    let params = { ...this.state.params }
    const find = params.experienceNumber.find(v => v === number)
    if (find) {
      const f = params.experienceNumber.filter(vf => vf !== number)
      params.experienceNumber = f
    } else {
      params.experienceNumber.push(number)
    }
    this.setState({ params })
  }

  changeBodyClass = (e, nameClass) => {
    e.preventDefault()
    this.setState({ selectedDate: '', selectedTime: '', preview: false })
    document.body.classList.add(nameClass)
    this.props.loadDate()
  }

  removeBodyClass = e => {
    if (e) e.preventDefault()
    document.body.className = 'p-0'
  }

  selectDate = (type, date) => {
    this.setState({ selectedDate: date, selectedTime: '' })
    this.props.loadSlot(
      this.props.getDoctor.doctors.data[this.state.doctorProfile]._id,
      date,
      type
    )
  }

  changeSwitch = type => {
    this.setState({ apType: type, selectedDate: '' })
  }

  formatAMPM(date) {
    var hours = new moment(date, 'HH').utc().hour()
    var minutes = new moment(date, 'mm').utc().minutes()
    var ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  changePreview = preview => {
    this.setState({ preview })
  }

  changeTime = time => {
    this.setState({ selectedTime: time })
  }
  loadFunc = p => {
    this.setState({ page: this.state.page + 1 }, () =>
      this.props.loadDoctor(this.arrangeParam())
    )
  }
  loadFunc2 = p => {
    const filter = {
      field_type: this.state.params['field_type.id'],
      page: this.state.page2 + 1
    }
    this.setState({ page2: filter.page }, () =>
      this.props.earliestOnline(filter, this.earlistCallback)
    )
  }
  isFilterApplied = () => {
  const { params, name } = this.state
  return (
    params.gender.length > 0 ||
    params.cityId.length > 0 ||
    params.feesNumber.length > 0 ||
    params.physicalFee.length > 0 ||
    params.language.length > 0 ||
    params.experienceNumber.length > 0
  )
}
  toggleFilter = (key, value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [key]: value,
      },
      activeModal: null,
    }));
  };

  setEarliestOnline = () => {

    this.setState({
      viewMode: "earliest",
      loadingEarliest: true, 
      filters: {
        earliestOnline: true,
        feeRange: null,
        physicalFee: null,
        experienceNumber: null,
        language: null,
        gender: null,
        city: null,
      },
    })
    const params = {
      field_type: this.state.params['field_type.id'],
      page: 1
    }
    this.props.earliestOnline(params, this.earlistCallback)
  }

  earlistCallback = (res) => {
    // console.log("Full response:", res);

    const list = res?.data?.earliest;

    if (Array.isArray(list)) {
      this.setState({
        earliestDoctors: list,
        loadingEarliest: false
      });
    } else {
      console.log("earliest is not an array:", list);
    }
  };


  getCityLabel = (cityId) => {
    const cityObj = this.props.getMisc.filterCity.find(c => c._id === cityId);
    return cityObj ? cityObj.city : null;
  };

  updateFilters = (updates, callback) => {
  this.setState((prevState) => ({
    filters: {
      ...prevState.filters,
      ...updates,
    },
    activeModal: null,
  }),
  callback
)
};

mapToIndex = (field, options ) => {
  return options.indexOf(field) + 1;
};


syncFiltersToParams = () => {
  const { filters } = this.state;

  this.setState((prevState) => {
    let params = { ...prevState.params };

    // reset fee params
    params.feesNumber = [];
    params.physicalFee = [];

    if (filters.feesNumber) {
      const index = this.mapToIndex(filters.feesNumber, feeRanges );
      if (index > 0) params.feesNumber = [index];
    }

    if (filters.physicalFee) {
      const index = this.mapToIndex(filters.physicalFee, feeRanges);
      if (index > 0) params.physicalFee = [index];
    }

    if (filters.experienceNumber) {
      const index = this.mapToIndex(filters.experienceNumber, expYears);
      if (index > 0) params.experienceNumber = [index];
    }

    params.language = filters.language ? [filters.language] : [];

    params.gender = filters.gender ? [filters.gender] : [];

    params.cityId = filters.city ? [filters.city] : [];

    return { params };
  }, () => {
    this.props.loadDoctor(this.arrangeParam());
  });
};

clearFilter = (key) => {
  this.setState(
    (prev) => ({
      filters: {
        ...prev.filters,
        [key]: null,
      },
      params: {
        ...prev.params,
        [key]: [],
      },
      activeModal: null,
    }),
    () => {
      this.props.loadDoctor(this.arrangeParam());
    }
  );
};

clearEarliestOnline = () => {
  this.setState(
    (prev) => ({
      viewMode: "all",
      filters: {
        ...prev.filters,
        
        earliestOnline: false,
      },
    }),
    () => {
      this.props.loadDoctor(this.arrangeParam());
    }
  );
};

formatSlot = (date) => {
  const slot = moment.utc(date);   

  if (slot.isSame(moment.utc(), "day")) {
    return `Today ${slot.format("h:mm A")}`;
  }

  if (slot.isSame(moment.utc().add(1, "day"), "day")) {
    return `Tomorrow ${slot.format("h:mm A")}`;
  }

  return slot.format("DD MMM h:mm A");
};


  render() {
    const { constants } = this.props.getMisc
    const { filters } = this.state;
    const isEarliestOnlineActive = filters.earliestOnline;

    const { footer_email_address, facebook, instagram, twitter } = constants
    const isProduction = process.env.REACT_APP_MODE === "production";
    return (
      <React.Fragment>
        <Helmet>
          <title>
            Book Appointment | Online Psychiatrists & Psychologists Consultation | YesMindy
          </title>

          <meta
            name="description"
            content="Book your appointment with YesMindy’s licensed psychiatrists & psychologists online. Confidential therapy & psychiatric consultations for anxiety, depression, OCD, stress, bipolar disorder, and more."
          />

          <meta
            name="keywords"
            content="Book Appointment YesMindy, Online Psychiatrist India, Online Psychologist India, Therapy Consultation Online, Schedule Psychiatrist Appointment, Book Therapy Session, Mental Health Care India"
          />
          <meta name="robots" content={isProduction ? "index, follow" : "noindex, nofollow"} />
          <meta name="googlebot" content={isProduction ? "index, follow" : "noindex, nofollow"} />

          <link rel="canonical" href="https://yesmindy.com/mentalhealthprofessional" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Book Appointment | YesMindy" />
          <meta property="og:description" content="Schedule confidential therapy or psychiatry appointments online with YesMindy’s licensed experts." />
          <meta property="og:url" content="https://yesmindy.com/mentalhealthprofessional" />
          <meta property="og:site_name" content="YesMindy" />
          <meta property="og:image" content="https://yesmindy.com/yes-mindy-color-logo-small.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Book Mental Health Appointment | YesMindy" />
          <meta name="twitter:description" content="Book online psychiatrist & psychologist consultations with YesMindy. Therapy & psychiatry available from the comfort of home." />
          <meta name="twitter:image" content="https://yesmindy.com/yes-mindy-color-logo-small.png" />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Book Appointment | YesMindy",
              "description": "Book a psychiatrist or psychologist consultation online with YesMindy.",
              "url": "https://yesmindy.com/mentalhealthprofessional",
              "potentialAction": {
                "@type": "Action",
                "name": "Book Online Consultation",
                "target": "https://yesmindy.com/mentalhealthprofessional"
              }
            })}
          </script>
        </Helmet>
        <LoadingBar color='#621ac0' ref={ref} shadow={true} />
        <Header
          name={this.state.name}
          setName={this.setName}
          params={this.state.params}
          applyFilter={this.applyFilter}
          changeGender={this.changeGender}
          filterCity={this.props.getMisc.filterCity}
          filterLanguages={this.props.getMisc.filterLanguages}
          changeCity={this.changeCity}
          changeFees={this.changeFees}
          changePhysicalFees={this.changePhysicalFees}
          changeLang={this.changeLang}
          changeExp={this.changeExp}
        />
        <main className='outer-container'>
          <div className='content-container service-container mob-pt-0'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='service-box'>
                    {this.state.customer.customer_first_name && (
                      <div class='service-head d-lg-flex flex-wrap align-items-lg-center justify-content-lg-between d-none d-lg-block'>
                        <h2>
                          Hello,{' '}
                          {`${this.state.customer.customer_first_name} ${this.state.customer.customer_last_name}`}{' '}
                          !
                        </h2>
                        <a
                          href='#!'
                          class='go-to-dashbord-box d-flex align-items-center'>
                          <div class='gtd-icon'>
                            <img src={dashbImg} alt='' />
                          </div>
                          <div class='gtd-text-box'>Go to dashboard</div>
                        </a>
                      </div>
                    )}
                    <div className='service-head d-lg-flex flex-wrap align-items-lg-center justify-content-lg-between d-none d-lg-block'>
                      <div class='heading w-auto mb-0'>
                          <h5>
                            Select <span>services</span>
                          </h5>
                      </div>
                    </div>
                      {/* <div class='heading w-auto mb-0'>
                          <span>Search results</span>
                      </div> */}
                    <div className='service-body d-lg-flex flex-wrap'>
                      <div className='sb-left'>
                        <div className='nav flex-lg-column nav-pills vertical-nav'>
                          {this.props.getMisc.fieldTypes.map((el, i) => (
                            <a
                              className={
                                this.state.params['field_type.id'] === el.id
                                  ? 'nav-link active'
                                  : 'nav-link'
                              }
                              href='#!'
                              onClick={e =>
                                this.updateParams('field_type.id', el.id, e)
                              }>
                              <div className='pills-content-box d-flex flex-wrap align-items-center'>
                                <div className="pc-img-box d-flex justify-content-center align-items-center">
                                  <img
                                    className="d-none d-lg-block"
                                    src={i === 0 ? specialist4 : i === 1 ? consultation : ill}
                                    alt=""
                                  />

                                  {/* Mobile icons */}
                                  <div className="d-block d-lg-none">
                                    {i === 0 && <i className="fa-sharp fa-solid fa-head-side-medical fa-xs" style={{ color: "#60449b" }}></i>}
                                    {i === 1 && <i className="fa-sharp fa-solid fa-head-side-circuit fa-xs" style={{ color: "#60449b" }}></i>}
                                    {i === 2 && <i className="fa-solid fa-hands-holding-heart fa-xs" style={{ color: "#60449b" }}></i>}
                                  </div>
                                </div>

                                <div className='pc-text-box'>
                                  <h3>{el.name}</h3>
                                </div>
                              </div>
                            </a>
                          ))}

                          <Link
                            className="nav-link d-none d-lg"
                            to="/faq"
                          >
                            <div className="pills-content-box d-flex flex-wrap align-items-center">
                              <div className="pc-img-box d-flex justify-content-center align-items-center">
                                <img className="d-none d-lg-block" src={"/communication (5).png"} alt="" />
                                <div className="d-block d-lg-none">
                                  <i className="fa-solid fa-comments-question fa-xs" style={{ color: "#60449b" }}></i>
                                </div>
                              </div>
                              <div className="pc-text-box">
                                <h3>Few Queries</h3>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      <div className='search-box d-block d-lg-none mb-3'>
                        <input
                          value={this.state.name}
                          onChange={this.setName}
                          type='text'
                          className='search-input'
                          placeholder='Search for doctor or location here'
                        />
                      </div>
                      <div className='sb-right'>
                      {this.isFilterApplied() && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="results">
                        <span
                          className="btn btn-outline-secondary btn-sm"
                          style={{ pointerEvents: 'none', textDecoration: 'underline' }}
                        >
                          All results
                        </span>
                      </div>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.handleResetFilters}
                      >
                        Reset Filters
                      </button>
                      </div>
                      )}

                        <div className='card'>
                        {this.state.viewMode === 'all' &&                        
                          <InfiniteScroll
                            pageStart={1}
                            initialLoad={false}
                            loadMore={this.loadFunc}
                            hasMore={
                              !this.props.getDoctor.doctors.doctorLoading &&
                              this.props.getDoctor.doctors.pagination
                                .filtered_record !==
                                this.props.getDoctor.doctors.pagination
                                  .total_record_on_current_page
                            }
                            loader={
                              <div className='loader' key={0}>
                                Loading ...
                              </div>
                            }
                            >
                            {!this.props.getDoctor.doctorLoading && (
                              <>
                                {this.props.getDoctor.doctors.data.length ? (
                                  this.props.getDoctor.doctors.data.map(
                                    (ed, i) => (
                                      <div className='card-box'>
                                        <div className='cb-upper d-flex flex-wrap align-items-start'>
                                          <div className='cb-upper-content d-flex flex-wrap'>
                                            <div className='cb-img-box'>
                                              <a
                                                href={'/dr/' + ed.user_name}
                                                target='_blank'>
                                                <img
                                                  src={
                                                    process.env
                                                      .REACT_APP_S3URL +
                                                    ed.image_url
                                                  }
                                                  alt=''
                                                />
                                              </a>
                                            </div>
                                            <div class='cb-text-box'>
                                              <div class='doc-intro-desc  font-montserrat'>
                                                <h5>
                                                  {' '}
                                                  <a
                                                    href={'/dr/' + ed.user_name}
                                                    target='_blank'>
                                                    {ed.name}
                                                  </a>
                                                </h5>
                                                <h6>
                                                  {ed.graduation &&
                                                    ed.graduation.education}
                                                  {ed.post_graduation &&
                                                    ', ' +
                                                      ed.post_graduation
                                                        .education}
                                                  {ed.super_speciality &&
                                                    ', ' +
                                                      ed.super_speciality
                                                        .education}
                                                </h6>
                                                <h6> {ed.field_type.name}</h6>
                                                {ed.certification && (
                                                  <h6>
                                                    {' '}
                                                    {ed.certification.length >
                                                      0 &&
                                                      ed.certification[0]
                                                        .title +
                                                        '(' +
                                                        ed.certification[0]
                                                          .place +
                                                        ')'}
                                                  </h6>
                                                )}
                                                <h6>
                                                  {' '}
                                                  {ed.total_experience} Years
                                                  Experience
                                                </h6>
                                                {ed.practice_preferences
                                                  .language.length > 0 && (
                                                  <h6>
                                                    Speaks:{' '}
                                                    {ed.practice_preferences.language.map(
                                                      (e, i) => (
                                                        <>
                                                          <span>{e}</span>
                                                          {ed
                                                            .practice_preferences
                                                            .language.length -
                                                            1 !==
                                                            i && ', '}
                                                        </>
                                                      )
                                                    )}
                                                  </h6>
                                                )}
                                                <div class='doc-loc-name d-flex align-items-center'>
                                                  <div class='location-pin-icon'>
                                                    <img
                                                      src={locationIcon}
                                                      alt=''
                                                    />
                                                  </div>{' '}
                                                  <span>
                                                    {ed.clinic_details.city}
                                                  </span>
                                                </div>
                                                <div class='doc-fee-desc'>
                                                  {ed.schedules.clinicFee &&
                                                  ed.schedules.clinicFee > 0 ? (
                                                    <div class='d-flex align-items-center'>
                                                      {' '}
                                                      <strong>
                                                        Physical Fee:{' '}
                                                      </strong>
                                                      <ul class='fee-list d-flex align-items-center'>
                                                        <li>
                                                          ₹{' '}
                                                          {
                                                            ed.schedules
                                                              .clinicFee
                                                          }
                                                        </li>
                                                        <li>
                                                          {ed.schedules.time}
                                                          mins
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  ) : (
                                                    ''
                                                  )}

                                                  {ed.schedules.onlineFee &&
                                                  ed.schedules.onlineFee > 0 ? (
                                                    <div class='d-flex align-items-center'>
                                                      {' '}
                                                      <strong>
                                                        Online Fee:{' '}
                                                      </strong>
                                                      <ul class='fee-list d-flex align-items-center'>
                                                        <li>
                                                          ₹{' '}
                                                          {
                                                            ed.schedules
                                                              .onlineFee
                                                          }
                                                        </li>
                                                        <li>
                                                          {ed.schedules.time}
                                                          mins
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  ) : (
                                                    ''
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className='cb-btn'>
                                          {ed.field_type.name === "Counsellor" ? (
                                          <a
                                           href='https://wa.me/917042597742'
                                            className='btn btn-primary btn-block'
                                            >
                                            Chat
                                          </a>
                                        ) : (
                                          ed.user_name && (
                                            <a
                                              href={process.env.REACT_APP_BASEURL + "dr/" + ed.user_name}
                                              className='btn btn-primary btn-block onlineVisit'>
                                              View
                                            </a>
                                          )
                                        )}

                                            {/* {ed.schedules.clinicFee &&
                                            ed.schedules.clinicFee > 0 ? (
                                              <a
                                                href='#!'
                                                onClick={e => {
                                                  this.setState(
                                                    {
                                                      doctorProfile: i,
                                                      sideBar: 'appointment',
                                                    },
                                                    () => {
                                                      this.changeBodyClass(
                                                        e,
                                                        'toggled-tab'
                                                      )
                                                      this.changeSwitch(
                                                        'clinic'
                                                      )
                                                    }
                                                  )
                                                }}
                                                className='btn btn-primary btn-block physicalVisit'>
                                                Physical visit
                                              </a>
                                            ) : (
                                              ''
                                            )} */}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )
                                ) : (
                                  <div className='card-box'>
                                    <h4>No Records Found</h4>
                                  </div>
                                )}
                              </>
                            )}
                            {this.props.getDoctor.doctorLoading && (
                              <div style={{
                                height: "150px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }} key={0}>
                                <i
                                  className="fa-duotone fa-spinner-scale fa-spin pp"
                                  style={{
                                    "--fa-primary-color": "#f79040",
                                    "--fa-secondary-color": "#60449b",
                                    "--fa-secondary-opacity": 1,
                                    fontSize: "24px"
                                  }}
                                ></i>
                              </div>
                            )}
                          </InfiniteScroll>
                        }
                        {this.state.viewMode === 'earliest' &&
                          <InfiniteScroll
                            pageStart={1}
                            initialLoad={false}
                            loadMore={this.loadFunc2}
                            hasMore={
                              !this.props.getAppointment.loadingEarliest &&
                              this.props.getAppointment.doctors.pagination
                                .filtered_record !==
                                this.props.getAppointment.doctors.pagination
                                  .total_record_on_current_page
                            }
                            // loader={
                            //   <div className="loader text-center" key={0}>
                            //     <i
                            //       className="fa-duotone fa-spinner-scale fa-spin"
                            //       style={{
                            //         "--fa-primary-color": "#f79040",
                            //         "--fa-secondary-color": "#60449b",
                            //         "--fa-secondary-opacity": 1,
                            //         fontSize: "24px"
                            //       }}
                            //     ></i>
                            //   </div>
                            // }
                            >
                              {!this.props.getAppointment.loadingEarliest && (
                                <>
                                  {this.props.getAppointment.doctors.earliest?.length ? (
                                    this.props.getAppointment.doctors.earliest.map(
                                      (item, i) => {
                                        const ed = item.doctor_id
                                        return (
                                          <div className="card-box" key={i}>
                                            <div className="cb-upper d-flex flex-wrap align-items-start">

                                              <div className='cb-upper-content d-flex flex-wrap'>
                                                <div className='cb-img-box'>
                                                  <a
                                                    href={'/dr/' + ed.user_name}
                                                    target='_blank'>
                                                    <img
                                                      src={
                                                        process.env
                                                          .REACT_APP_S3URL +
                                                        ed.image_url
                                                      }
                                                      alt=''
                                                    />
                                                  </a>
                                                </div>
                                                <div class='cb-text-box'>
                                                  <div class='doc-intro-desc  font-montserrat'>
                                                    <h5>
                                                      {' '}
                                                      <a
                                                        href={'/dr/' + ed.user_name}
                                                        target='_blank'>
                                                        {ed.name}
                                                      </a>
                                                    </h5>
                                                    <h6>
                                                      {ed.graduation &&
                                                        ed.graduation.education}
                                                      {ed.post_graduation &&
                                                        ', ' +
                                                          ed.post_graduation
                                                            .education}
                                                      {ed.super_speciality &&
                                                        ', ' +
                                                          ed.super_speciality
                                                            .education}
                                                    </h6>
                                                    <h6> {ed.field_type.name}</h6>
                                                    {ed.certification && (
                                                      <h6>
                                                        {' '}
                                                        {ed.certification.length >
                                                          0 &&
                                                          ed.certification[0]
                                                            .title +
                                                            '(' +
                                                            ed.certification[0]
                                                              .place +
                                                            ')'}
                                                      </h6>
                                                    )}
                                                    <h6>
                                                      {' '}
                                                      {ed.total_experience} Years
                                                      Experience
                                                    </h6>
                                                    {ed.practice_preferences
                                                      .language.length > 0 && (
                                                      <h6>
                                                        Speaks:{' '}
                                                        {ed.practice_preferences.language.map(
                                                          (e, i) => (
                                                            <>
                                                              <span>{e}</span>
                                                              {ed
                                                                .practice_preferences
                                                                .language.length -
                                                                1 !==
                                                                i && ', '}
                                                            </>
                                                          )
                                                        )}
                                                      </h6>
                                                    )}
                                                    <div class='doc-loc-name d-flex align-items-center'>
                                                      <div class='location-pin-icon'>
                                                        <img
                                                          src={locationIcon}
                                                          alt=''
                                                        />
                                                      </div>{' '}
                                                      <span>
                                                        {ed.clinic_details.city}
                                                      </span>
                                                    </div>
                                                    {/* <div class='doc-fee-desc'>
                                                      {ed.schedules.clinicFee &&
                                                      ed.schedules.clinicFee > 0 ? (
                                                        <div class='d-flex align-items-center'>
                                                          {' '}
                                                          <strong>
                                                            Physical Fee:{' '}
                                                          </strong>
                                                          <ul class='fee-list d-flex align-items-center'>
                                                            <li>
                                                              ₹{' '}
                                                              {
                                                                ed.schedules
                                                                  .clinicFee
                                                              }
                                                            </li>
                                                            <li>
                                                              {ed.schedules.time}
                                                              mins
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      ) : (
                                                        ''
                                                      )}

                                                      {ed.schedules.onlineFee &&
                                                      ed.schedules.onlineFee > 0 ? (
                                                        <div class='d-flex align-items-center'>
                                                          {' '}
                                                          <strong>
                                                            Online Fee:{' '}
                                                          </strong>
                                                          <ul class='fee-list d-flex align-items-center'>
                                                            <li>
                                                              ₹{' '}
                                                              {
                                                                ed.schedules
                                                                  .onlineFee
                                                              }
                                                            </li>
                                                            <li>
                                                              {ed.schedules.time}
                                                              mins
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      ) : (
                                                        ''
                                                      )}
                                                    </div> */}
                                                    <div class="next-slot">
                                                      {ed.field_type.name != "Counsellor" && (
                                                        <>
                                                          <span class="label">Earliest Online Slot: </span>
                                                          <span class="date">{this.formatSlot(item.start)}</span>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className='cb-btn'>
                                              {ed.field_type.name === "Counsellor" ? (
                                                <a
                                                href='https://wa.me/917042597742'
                                                  className='btn btn-primary btn-block'
                                                  >
                                                  Chat
                                                </a>
                                              ) : (
                                                ed.user_name && (
                                                  <a
                                                    href={process.env.REACT_APP_BASEURL + "dr/" + ed.user_name}
                                                    className='btn btn-primary btn-block onlineVisit'>
                                                    View
                                                  </a>
                                                )
                                              )}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    )
                                  ) : (
                                    <div className="card-box">
                                      <h4>No Earliest Online Appointment Available</h4>
                                    </div>
                                  )}
                                </>
                              )}
                          </InfiniteScroll>
                        }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            {this.state.activeModal &&
              <>
                <FilterModal
                  activeModal={this.state.activeModal}
                  filters={this.state.filters}
                  closeModal={this.closeModal}
                  updateFilters={this.updateFilters}
                  filterCity={this.props.getMisc.filterCity}
                  filterLanguages={this.props.getMisc.filterLanguages}
                  syncFiltersToParams={this.syncFiltersToParams}
                  feeRanges={feeRanges}
                  expYears={expYears}
                />
              </>
            }
          <div className='bottom-filter-block d-block d-lg-none'>
            <div className='container'>
              <div className="filter-scroll d-flex">
                <FilterChip
                  label="Earliest Online Appointment"
                  value={filters.earliestOnline ? "Earliest Online" : null}
                  onClick={this.setEarliestOnline}
                  onClear={this.clearEarliestOnline}
                />

                <FilterChip
                  label="Fee Range"
                  value={
                    filters.feesNumber
                      ? `Online: ${filters.feesNumber}`
                      : filters.physicalFee
                      ? `Clinic: ${filters.physicalFee}`
                      : null
                  }
                  onClick={() => this.openModal("fee")}
                  onClear={() => {
                    this.clearFilter("feesNumber");
                    this.clearFilter("physicalFee");
                  }}
                  disabled={isEarliestOnlineActive}
                />
                <FilterChip
                  label="Language"
                  value={filters.language}
                  onClick={() => this.openModal("language")}
                  onClear={() => this.clearFilter("language")}
                  disabled={isEarliestOnlineActive}
                />
                <FilterChip
                  label="Experience"
                  value={filters.experienceNumber}
                  onClick={() => this.openModal("experienceNumber")}
                  onClear={() => this.clearFilter("experienceNumber")}
                  disabled={isEarliestOnlineActive}
                />
                <FilterChip
                  label="City"
                  value={this.getCityLabel(filters.city)}
                  onClick={() => this.openModal("city")}
                  onClear={() => this.clearFilter("city")}
                  disabled={isEarliestOnlineActive}
                />
                <FilterChip
                  label="Gender"
                  value={filters.gender}
                  onClick={() => this.openModal("gender")}
                  onClear={() => this.clearFilter("gender")}
                  disabled={isEarliestOnlineActive}
                />
              </div>
              {/* <div className='row'>
                <div className='col-md-12'>
                  <div className='filter-block-content d-flex align-items-center'>
                    <div className='sortby-drop dropdown'>
                      <div
                        className='filter-block d-flex align-items-center justify-content-center dropdown-toggle'
                        id='sortbyDropdown'
                        data-toggle='dropdown'
                        aria-haspopup='true'
                        aria-expanded='false'>
                        <div className='fb-icon'>
                          <img src='include/images/mob-sort-icon.svg' alt='' />
                        </div>
                        <div className='fb-text'>Sort by</div>
                      </div>
                      <div
                        className='dropdown-menu sortby-dropdown'
                        aria-labelledby='sortbyDropdown'>
                        <div className='custom-control-head'>
                          <div className='custom-control heading'>
                            <h6>SORT BY</h6>
                          </div>
                        </div>
                        <div className='custom-control-body'>
                          <div className='custom-control custom-radio'>
                            <input
                              type='radio'
                              id='customRadio1'
                              name='customRadio'
                              className='custom-control-input'
                            />
                            <label
                              className='custom-control-label'
                              htmlFor='customRadio1'>
                              Popularity
                            </label>
                          </div>
                          <div className='custom-control custom-radio'>
                            <input
                              type='radio'
                              id='customRadio2'
                              name='customRadio'
                              className='custom-control-input'
                            />
                            <label
                              className='custom-control-label'
                              htmlFor='customRadio2'>
                              Price -- High to Low
                            </label>
                          </div>
                          <div className='custom-control custom-radio'>
                            <input
                              type='radio'
                              id='customRadio3'
                              name='customRadio'
                              className='custom-control-input'
                            />
                            <label
                              className='custom-control-label'
                              htmlFor='customRadio3'>
                              Price -- Low to High
                            </label>
                          </div>
                          <div className='custom-control custom-radio'>
                            <input
                              type='radio'
                              id='customRadio4'
                              name='customRadio'
                              className='custom-control-input'
                            />
                            <label
                              className='custom-control-label'
                              htmlFor='customRadio4'>
                              Newest First
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <Footer
            footer_email_address={footer_email_address}
            facebook={facebook}
            instagram={instagram}
            twitter={twitter}
          />
        </main>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  loadFieldType: param => dispatch(loadFieldType(param)),
  loadFilterCity: () => dispatch(loadFilterCity()),
  loadFilterLanguages: () => dispatch(loadFilterLanguages()),
  loadDoctor: data => dispatch(loadDoctors(data)),
  earliestOnline: (params, callback) => dispatch(earliestOnline(params, callback)),
  loadDate: () => dispatch(loadDate()),
  loadSlot: (drId, date, type) => dispatch(loadSlot(drId, date, type)),
  createOrder: (data, callback) => dispatch(createOrder(data, callback)),
  updateOrder: (data, callback) => dispatch(updateOrder(data, callback)),
  loadPatientProfile: () => dispatch(loadPatientProfile()),
  setShowSuccessData: param => dispatch(setShowSuccessData(param)),
})

const mapStateToProps = state => ({
  getMisc: getMisc(state),
  getDoctor: getDoctor(state),
  getAppointment: getAppointment(state),
  getPatient: getPatient(state),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ourDoctors))
